<template>
  <div class="sample-wrapper">
    <mt-button @click="InvokeApi" type="primary">调用接口</mt-button>
    <mt-button @click="generateUUID" type="primary">生成UUID</mt-button>
  </div>
</template>

<script>
import ZJAPP from "./../../../app";
import MyApis from "./../../../../api";
import { Toast } from "mint-ui";

export default {
  name: "ZjEmergencyInvokeApi",
  data: function() {
    return {
      navs: []
    };
  },
  methods: {
    InvokeApi: function() {
      new MyApis.ExecutTaskApi()
        .FindByConditions({
          ExecutId: "a734f620-ad16-11ea-aa71-00155d38a404",
          Validity: 1
        })
        .then(r => {
          r = r.data.Data;
          Toast({
            message: JSON.stringify(r)
          });
        })
        .catch(e => {
          Toast({
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！"
          });
        });
    },
    generateUUID() {
      var uuid = ZJAPP.ZJUtils.uuid();
      Toast({
        message: JSON.stringify(uuid)
      });
    }
  },
  created() {},
  mounted() {},
  controller: "UI",
  action: "Api"
};
</script>
<style scoped>
.sample-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.sample-wrapper > * {
  margin: 1rem 0;
}
</style>